import React from "react";

//#region src/design/react/core/RegionContext.tsx
const RegionContext = React.createContext(null);
const useRegionContext = () => React.useContext(RegionContext);

//#endregion
export { useRegionContext as n, RegionContext as t };
//# sourceMappingURL=RegionContext.js.map